import React, { useEffect, useState } from "react";
import "../auth.css";
import { Form, Input, Button, Alert, ConfigProvider } from "antd";
import { UserOutlined, LockOutlined, LoginOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { onLogin } from "../../services";
import { useDispatch, useSelector } from "react-redux";
import { loginFailure, loginStart, loginSuccess } from "../../redux/user";
import logoImg from "../../components/navbar/logo";

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.user.currentUser);

  // daca e deja autentificat ca admin, nu are ce cauta pe /login
  useEffect(() => {
    if (currentUser?.role === "admin") {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  const onFinish = async (values) => {
    if (loading) return; // fara dublu-submit
    setErrorMsg(null);
    setLoading(true);
    dispatch(loginStart());
    try {
      const res = await onLogin({
        email: (values.email || "").trim(),
        password: values.password,
      });
      dispatch(loginSuccess(res.data));
      navigate("/");
    } catch (error) {
      dispatch(loginFailure());
      console.log(error);
      if (error.response) {
        // 400/403 de la backend = date gresite sau cont fara rol de admin
        setErrorMsg(
          "Email sau parolă incorectă, ori contul nu are drepturi de administrator."
        );
      } else {
        setErrorMsg(
          "Serverul nu răspunde. Verificați conexiunea la internet și încercați din nou."
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const token = {
    colorPrimary: "#f28737",
  };

  return (
    <ConfigProvider theme={{ token }}>
      <div className="auth-page">
        <div className="auth-card">
          <div className="auth-logo-wrap">
            <img src={logoImg} alt="Invoicer" className="auth-logo" />
          </div>
          <h1 className="auth-title">Panoul de administrare</h1>
          <p className="auth-subtitle">
            Autentificați-vă cu contul de administrator
          </p>

          {errorMsg ? (
            <Alert
              className="auth-error"
              type="error"
              showIcon
              message={errorMsg}
            />
          ) : null}

          <Form
            name="admin_login"
            layout="vertical"
            onFinish={onFinish}
            onValuesChange={() => errorMsg && setErrorMsg(null)}
            requiredMark={false}
          >
            <Form.Item
              name="email"
              label={<span className="auth-label">Email</span>}
              rules={[
                { required: true, message: "Introduceți adresa de email." },
                { type: "email", message: "Adresa de email nu este validă." },
              ]}
            >
              <Input
                size="large"
                prefix={<UserOutlined style={{ color: "#9c9ca1" }} />}
                placeholder="nume@exemplu.md"
                autoComplete="email"
                autoFocus
              />
            </Form.Item>

            <Form.Item
              name="password"
              label={<span className="auth-label">Parola</span>}
              rules={[{ required: true, message: "Introduceți parola." }]}
            >
              <Input.Password
                size="large"
                prefix={<LockOutlined style={{ color: "#9c9ca1" }} />}
                placeholder="••••••••"
                autoComplete="current-password"
              />
            </Form.Item>

            <Button
              type="primary"
              htmlType="submit"
              className="auth-submit"
              loading={loading}
              icon={loading ? null : <LoginOutlined />}
            >
              {loading ? "Se verifică..." : "Autentificare"}
            </Button>
          </Form>

          <p className="auth-footer">
            Acces permis doar administratorilor. Gestionarii folosesc aplicația
            gestionar.invoicer.md.
          </p>
        </div>
      </div>
    </ConfigProvider>
  );
};

export default Login;
